module.exports = __webpack_public_path__ + "static/wash_card_img3@2x-4c8f9735c56339672d77b9acf848dc82.jpg";